










































































































import Vue, { PropType } from 'vue';
import CardLayout from '@/components/card-layout/CardLayout.vue';
import { HomeSummary, JobProgress, Photos } from '@/types';
import { checkImageUrl, defaultHomeImage, hideLoader } from '@/util';
import { mapGetters } from 'vuex';
import { format } from 'date-fns';
import store from '@/store';
import { ActionType, JobStatus } from '@/constants/enums';
import { getMyPhotos } from '@/api';
import ImageSelector from './ImageSelector.vue';

export default Vue.extend({
  name: 'HomeProfile',
  components: {
    CardLayout,
    ImageSelector
  },
  data () {
    return {
      phaseProgressData: {} as JobProgress,
      photos: [] as Photos[],
      showImageSelector: false
    }
  },
  mounted () {
    this.fetchPhotos();
  },
  props: {
    homeDetail: {
      type: Object as PropType<HomeSummary>,
      required: true
    },
    preClose: {
      type: Boolean,
      required: true
    },
    phaseProgress: {
      type: Object as unknown as PropType<JobProgress>
    }
  },
  computed: {
    ...mapGetters(['user', 'selectedJobBuyers', 'mileStones', 'jobOwnershipStatus']),
    fillStroke (): number {
      const length = 349.5177307128906;
      const to =
          length * ((100 - this.phaseProgress.completePercentage) / 100);
      return Math.max(0, Math.round(to));
    },
    closeDate (): string {
      return this.mileStones?.Own?.steps[1]?.actualCloseDate || '';
    },
    showClosingDate (): boolean {
      return !!this.closeDate && this.jobOwnershipStatus !== JobStatus.PRE_CLOSE;
    },
    getClosingDate (): string {
      const dateStr = this.closeDate + 'T00:00:00';
      return this.closeDate ? format(new Date(dateStr), 'MM/dd/yyyy') : '';
    }
  },
  methods: {
    onHomeImageError (event: Event) {
      (event.target as HTMLImageElement).src = defaultHomeImage();
    },
    async fetchPhotos () {
      const jobId = localStorage.getItem('selectedJob');
      jobId && await getMyPhotos(jobId, -1).then(async (data) => {
        if (data) {
          this.photos = data.photos;
          this.photos = await checkImageUrl(this.photos);
        }
      });
    },
    toggleImageSelector (show: boolean) {
      this.showImageSelector = show;
    }
  }
})
